import {UnloadingMethodForm} from '../../../fields/unloadingMethod/types'

export const buildUnloadingMethodForm = (): UnloadingMethodForm => {
  return {
    unloadingMethod: {}
  }
}
